<div
  class="ion-activatable"
  [style.padding]="size == 'sm' ? '10px' : 'var(--ion-padding)'"
  [ngClass]="type == 'button' ? 'myaccount-button' : ''"
>
  <ion-icon
    [name]="icon"
    [style.color]="!type ? color : 'var(--ion-text-color)'"
    [style.font-size]="
      size == 'lg'
        ? 'calc(var(--bepatient-font-size-h4) * 2)'
        : 'var(--bepatient-font-size-h1)'
    "
  ></ion-icon>
  <span [class.bp-rtl]="document.dir === 'rtl'">{{ label }}</span>

  <svg
    [class.bp-rtl]="document.dir === 'rtl'"
    width="10"
    height="17"
    viewBox="0 0 10 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    *ngIf="!type || type != 'button'"
  >
    <path
      d="M1 1L9 8.5L1 16"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <ion-ripple-effect></ion-ripple-effect>
</div>
